import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';


class ScheduleGradeAircraftLineGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      schedule_id: this.props.schedule_id,
      schedule_grade_id: this.props.schedule_grade_id,
      sgas_id: this.props.sgas_id,
      line: this.props.line,
      edit_mode: this.props.edit_mode,
    };

  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
    if (event.target.value !== '') {
      this.props.changeGroup(event.target.value, this.state.sgas_id);
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.line !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        line: newProps.line,
        sgas_id: newProps.sgas_id,
        loaded: 1,
      });
    }
    this.setState({edit_mode: newProps.edit_mode});
  }

  render() {
    var self = this;
    return (
      
  <td className={"text-center table-schedule-sticky table-schedule-main-group-" + self.props.zoom_level}>
    <RequestApi ref={'request_api'} handleLoaded={this.props.handleLoaded} />
    {self.state.edit_mode ? <input name="line" value={this.state.line} onChange={this.handleChange.bind(this, 'line')} style={{width: '20px', textAlign: 'center'}} /> : this.state.line}
  </td>
    );
  }
}

export default ScheduleGradeAircraftLineGroup;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeAircraftLineGroup.js